module.exports = __webpack_public_path__ + "static/media/stjerne_gul-min.7c509013.png";